import React from 'react';
import './Thesis.css';

const Thesis = () => {
  return (
    <div className="thesis-container">
      <div className="thesis-card">
        <div className="thesis-card-header">
          <h1 className="thesis-header">MSEE Thesis</h1>
          <p className="thesis-subheader">Enhanced Swim Pose Recognition</p>
        </div>
        <p className="thesis-paragraph">
          View my thesis exploring dataset expansion and optimized training techniques for swim pose recognition.
        </p>
        <a
          href="/data/thesis-report.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="thesis-cta"
          aria-label="Open Thesis PDF"
        >
          <span className="thesis-cta-icon" aria-hidden>📄</span>
          <span>Open Thesis PDF</span>
        </a>
      </div>
    </div>
  );
};

export default Thesis;
